module.exports = __webpack_public_path__ + "img/manajemen_korporat.21b0311b.svg";